import React from "react";

export interface PriceBook {
  id: string;
  name: string;
  description: string;
  currency: string;
}

export interface PackageType {
  id: string;
  name: string;
  isDefault: boolean;
}

export const DEFAULT_PACKAGE_TYPES: PackageType[] = [
  { id: "pt1", name: "Labor", isDefault: true },
  { id: "pt3", name: "Travel", isDefault: true },
  { id: "pt2", name: "Service", isDefault: true },
  { id: "pt4", name: "Shipping", isDefault: true },
  { id: "pt5", name: "Carriage", isDefault: true },
];

export const DEFAULT_PRICE_BOOKS: PriceBook[] = [
  { id: "pb1", name: "Standard Rate Card",    description: "Default pricing for labour, parts, and travel",          currency: "EUR" },
  { id: "pb2", name: "Premium Service Rates", description: "Priority response rates for premium contract customers",  currency: "EUR" },
];

export interface FinanceConfig {
  senderName: string;
  street: string;
  city: string;
  postalCode: string;
  country: string;
  vatId: string;
  taxNumber: string;
  iban: string;
  bic: string;
  paymentTerms: string;
  currency: string;
  invoicePrefix: string;
  quotationPrefix: string;
  invoiceNotes: string;
  quotationNotes: string;
  defaultMargin: number;
  headerImage: string | null;
  footerImage: string | null;
  priceBooks: PriceBook[];
  packageTypes: PackageType[];
}

const DEFAULT_CONFIG: FinanceConfig = {
  senderName: "Makula GmbH",
  street: "Am Kölner Hof 13",
  city: "Köln",
  postalCode: "50679",
  country: "Germany",
  vatId: "DE123456789",
  taxNumber: "",
  iban: "DE89 3704 0044 0532 0130 00",
  bic: "COBADEFFXXX",
  paymentTerms: "30",
  currency: "EUR",
  invoicePrefix: "INV-",
  quotationPrefix: "QUO-",
  invoiceNotes: "",
  quotationNotes: "",
  defaultMargin: 0,
  headerImage: null,
  footerImage: null,
  priceBooks: DEFAULT_PRICE_BOOKS,
  packageTypes: DEFAULT_PACKAGE_TYPES,
};

interface FinanceConfigContextValue {
  config: FinanceConfig;
  setConfig: (cfg: FinanceConfig) => void;
}

const FinanceConfigContext = React.createContext<FinanceConfigContextValue>({
  config: DEFAULT_CONFIG,
  setConfig: () => {},
});

export function FinanceConfigProvider({ children }: { children: React.ReactNode }) {
  const [config, setConfig] = React.useState<FinanceConfig>(DEFAULT_CONFIG);
  return (
    <FinanceConfigContext.Provider value={{ config, setConfig }}>
      {children}
    </FinanceConfigContext.Provider>
  );
}

export function useFinanceConfig() {
  return React.useContext(FinanceConfigContext);
}
